const blank = (n = 20) => `<span class="blank">${"_".repeat(n)}</span>`;
const val = (v, fallbackLen = 20) =>
  v ? `<strong>${v}</strong>` : blank(fallbackLen);

const conventionIT = (d) => `
<h1>CONVENZIONE DI ADESIONE E AUTOCERTIFICAZIONE "STORE EXTRACONOMY"</h1>
<p>Il presente documento costituisce un accordo vincolante tra la piattaforma <em>Extraconomy</em>
(di seguito denominata "Piattaforma") e il Partner Commerciale (di seguito denominato "Store")
che sottoscrive la presente convenzione.</p>

<h2>1. Dati del Richiedente e dello Store (Autocertificazione)</h2>
<p>
  Il/La sottoscritto/a ${val(d.legalRepresentativeName, 30)},
  in qualità di Legale Rappresentante / Titolare della ditta/società ${val(d.company, 30)},
</p>
<ul>
  <li><strong>Partita IVA / C.F.:</strong> ${val(d.taxId, 20)}</li>
  <li><strong>Insegna Commerciale dello Store:</strong> ${val(d.storeName, 25)}</li>
  <li><strong>Indirizzo Sede Operativa (Negozio Fisico):</strong>
    Via/Piazza ${val(d.address, 20)} n.${val(d.number, 5)}</li>
  <li><strong>CAP:</strong> ${val(d.postalCode, 8)}
      <strong>Città:</strong> ${val(d.city, 15)}
      <strong>Provincia:</strong> ${val(d.state, 5)}</li>
  <li><strong>Categoria Merceologica:</strong> ${val(d.merchantCategory, 20)}</li>
  <li><strong>Contatti:</strong> Tel. ${val(d.phone, 15)} Email: ${val(d.email, 25)}</li>
</ul>
<p>Consapevole delle sanzioni penali previste in caso di dichiarazioni mendaci e di formazione o
uso di atti falsi (art. 76 D.P.R. 28 dicembre 2000, n. 445), sotto la propria responsabilità:</p>

<h3>DICHIARA E AUTOCERTIFICA</h3>
<ol>
  <li><strong>Esistenza Reale del Punto Vendita:</strong> Che l'attività commerciale sopra
    indicata corrisponde a un <strong>negozio fisico realmente esistente</strong>, operativo e
    aperto al pubblico all'indirizzo segnalato.</li>
  <li><strong>Titolarità:</strong> Di possedere i pieni poteri legali e le autorizzazioni
    necessarie per iscrivere l'attività alla piattaforma Extraconomy.</li>
  <li><strong>Veridicità degli Allegati:</strong> Che la documentazione fotografica allegata alla
    presente richiesta (Foto dell'esterno del locale/insegna) è autentica, recente e rappresenta
    fedelmente lo stato attuale dello Store.</li>
</ol>

<h2>2. Oggetto della Convenzione e Geolocalizzazione</h2>
<p>Con l'approvazione della presente convenzione, lo Store entra a far parte dell'ecosistema Extraconomy.</p>
<ul>
  <li><strong>Mappatura e Visibilità:</strong> Lo Store accetta che i propri dati (Insegna,
    indirizzo, categoria e orari) vengano inseriti nella mappa interattiva della Piattaforma.
    Diventerà così geolocalizzabile e rintracciabile da parte degli utenti registrati.</li>
  <li><strong>Accettazione Extracredit:</strong> Lo Store si impegna formalmente e solennemente ad
    accettare gli <strong>Extracredit</strong> accumulati dagli utenti nel loro portafoglio
    digitale come metodo di pagamento (parziale o totale, secondo le percentuali di accettazione
    stabilite nel proprio profilo Store sulla Piattaforma).</li>
  <li><strong>Offerta Cashback:</strong> Lo Store accetta di offrire automaticamente un cashback
    dell'1%, impostato automaticamente nel sistema di vendita Extraconomy, sul valore del prodotto
    o servizio venduto attraverso le transazioni di acquisto realizzate tramite il trasferimento
    tra wallet digitali di utenti Extraconomy utilizzando la tecnologia QR Code.</li>
</ul>

<h2>3. Termini e Condizioni di Partecipazione</h2>
<p>Lo Store dichiara di aver letto, compreso e di accettare integralmente i Termini e Condizioni
generali della piattaforma Extraconomy, con particolare attenzione ai seguenti punti:</p>
<ul>
  <li><strong>Gestione delle Transazioni:</strong> Le transazioni in Extracredit avverranno
    tramite l'applicazione o i sistemi digitali forniti da Extraconomy. Lo Store si impegna a
    formare il proprio personale per la corretta gestione dei pagamenti digitali.</li>
  <li><strong>Trasparenza:</strong> Lo Store si impegna a non applicare maggiorazioni di prezzo
    o condizioni svantaggiose agli utenti che decidono di pagare in Extracredit rispetto ai
    clienti tradizionali.</li>
  <li><strong>Aggiornamento Dati:</strong> È responsabilità dello Store comunicare
    tempestivamente a Extraconomy qualsiasi variazione di indirizzo, chiusura
    temporanea/definitiva o cambio di gestione.</li>
</ul>

<h2>4. Allegati Obbligatori</h2>
<p>Per completare l'attivazione sulla mappa, lo Store allega al presente modulo:</p>
<ul>
  <li>☐ <strong>Foto dell'esterno del negozio</strong> (chiara, visibile e con l'insegna
    commerciale leggibile).</li>
  <li>☐ Copia del documento d'identità del Legale Rappresentante (se la firma non è digitale).</li>
</ul>

<h2>5. Trattamento dei Dati Personali (GDPR)</h2>
<p>I dati personali raccolti saranno trattati da Extraconomy nel rispetto del Regolamento UE
2016/679. Il trattamento è finalizzato esclusivamente all'erogazione dei servizi legati alla
piattaforma, alla geolocalizzazione sulla mappa e alla gestione del circuito di credito.</p>

<h3>FIRMA PER ACCETTAZIONE E SOTTOSCRIZIONE</h3>
<p><strong>Luogo e Data:</strong> ${val(d.city, 15)}, ${val(d.date, 15)}</p>
<p><em>Il Legale Rappresentante / Titolare dello Store</em> (Firma digitale o firma autografa leggibile)</p>
<div class="signature-box">${val(d.legalRepresentativeName, 30)}</div>
<p style="margin-top:24px;font-size:0.9em;">Ai sensi degli artt. 1341 e 1342 c.c., il sottoscritto approva specificamente le clausole di
cui all'Art. 1 (Autocertificazione e responsabilità), Art. 2 (Accettazione Extracredit e
geolocalizzazione) e Art. 3 (Termini e condizioni e divieto di maggiorazioni).</p>
<div class="signature-box">${val(d.legalRepresentativeName, 30)}</div>
`;

const conventionPT = (d) => `
<h1>CONVENÇÃO DE ADESÃO E AUTODECLARAÇÃO "STORE EXTRACONOMY"</h1>
<p>O presente documento constitui um acordo vinculativo entre a plataforma <em>Extraconomy</em>
(doravante denominada "Plataforma") e o Parceiro Comercial (doravante denominado "Store")
que subscreve a presente convenção.</p>

<h2>1. Dados do Requerente e da Loja (Autodeclaração)</h2>
<p>
  O/A abaixo assinado/a ${val(d.legalRepresentativeName, 30)},
  na qualidade de Representante Legal / Titular da empresa ${val(d.company, 30)},
</p>
<ul>
  <li><strong>CNPJ / CPF:</strong> ${val(d.taxId, 20)}</li>
  <li><strong>Nome Comercial da Loja:</strong> ${val(d.storeName, 25)}</li>
  <li><strong>Endereço da Sede Operacional (Loja Física):</strong>
    ${val(d.address, 20)}, n.º ${val(d.number, 5)}</li>
  <li><strong>CEP:</strong> ${val(d.postalCode, 8)}
      <strong>Cidade:</strong> ${val(d.city, 15)}
      <strong>Estado:</strong> ${val(d.state, 5)}</li>
  <li><strong>Categoria do Estabelecimento:</strong> ${val(d.merchantCategory, 20)}</li>
  <li><strong>Contactos:</strong> Tel. ${val(d.phone, 15)} E-mail: ${val(d.email, 25)}</li>
</ul>
<p>Ciente das penalidades previstas para declarações falsas nos termos da legislação vigente,
sob sua responsabilidade:</p>

<h3>DECLARA E AUTOCERTIFICA</h3>
<ol>
  <li><strong>Existência Real do Ponto de Venda:</strong> Que a atividade comercial indicada acima
    corresponde a uma <strong>loja física realmente existente</strong>, operacional e aberta ao
    público no endereço indicado.</li>
  <li><strong>Titularidade:</strong> Que possui os plenos poderes legais e as autorizações
    necessárias para inscrever a atividade na plataforma Extraconomy.</li>
  <li><strong>Veracidade dos Anexos:</strong> Que a documentação fotográfica anexa à presente
    solicitação (foto do exterior do estabelecimento/insígnia) é autêntica, recente e representa
    fielmente o estado atual da Loja.</li>
</ol>

<h2>2. Objeto da Convenção e Geolocalização</h2>
<p>Com a aprovação da presente convenção, a Loja passa a integrar o ecossistema Extraconomy.</p>
<ul>
  <li><strong>Mapeamento e Visibilidade:</strong> A Loja aceita que os seus dados (Nome comercial,
    endereço, categoria e horários) sejam inseridos no mapa interativo da Plataforma, tornando-se
    geolocalizada e encontrável pelos utilizadores registados.</li>
  <li><strong>Aceitação de Extracredit:</strong> A Loja compromete-se a aceitar os
    <strong>Extracredit</strong> acumulados pelos utilizadores na sua carteira digital como método
    de pagamento (parcial ou total, de acordo com as percentagens definidas no seu perfil Store
    na Plataforma).</li>
  <li><strong>Oferta de Cashback:</strong> A Loja aceita oferecer automaticamente um cashback de
    1%, configurado automaticamente no sistema de vendas Extraconomy, sobre o valor do produto
    ou serviço vendido através das transações de compra realizadas mediante a transferência
    entre carteiras digitais de utilizadores Extraconomy, utilizando a tecnologia QR Code.</li>
</ul>

<h2>3. Termos e Condições de Participação</h2>
<p>A Loja declara ter lido, compreendido e aceite integralmente os Termos e Condições gerais da
plataforma Extraconomy, com especial atenção aos seguintes pontos:</p>
<ul>
  <li><strong>Gestão de Transações:</strong> As transações em Extracredit serão realizadas através
    da aplicação ou dos sistemas digitais fornecidos pela Extraconomy. A Loja compromete-se a
    formar o seu pessoal para a correta gestão dos pagamentos digitais.</li>
  <li><strong>Transparência:</strong> A Loja compromete-se a não aplicar majorações de preço ou
    condições desvantajosas aos utilizadores que optarem por pagar em Extracredit relativamente
    aos clientes tradicionais.</li>
  <li><strong>Atualização de Dados:</strong> É responsabilidade da Loja comunicar prontamente à
    Extraconomy qualquer alteração de endereço, encerramento temporário/definitivo ou mudança de
    gestão.</li>
</ul>

<h2>4. Anexos Obrigatórios</h2>
<p>Para completar a ativação no mapa, a Loja anexa ao presente formulário:</p>
<ul>
  <li>☐ <strong>Foto do exterior da loja</strong> (clara, visível e com a insígnia comercial
    legível).</li>
  <li>☐ Cópia do documento de identificação do Representante Legal (se a assinatura não for
    digital).</li>
</ul>

<h2>5. Tratamento de Dados Pessoais (RGPD)</h2>
<p>Os dados pessoais recolhidos serão tratados pela Extraconomy em conformidade com o Regulamento
UE 2016/679. O tratamento destina-se exclusivamente à prestação dos serviços da plataforma,
à geolocalização no mapa e à gestão do circuito de crédito.</p>

<h3>ASSINATURA PARA ACEITAÇÃO E SUBSCRIÇÃO</h3>
<p><strong>Local e Data:</strong> ${val(d.city, 15)}, ${val(d.date, 15)}</p>
<p><em>O Representante Legal / Titular da Loja</em> (Assinatura digital ou assinatura manuscrita
legível)</p>
<div class="signature-box">${val(d.legalRepresentativeName, 30)}</div>
<p style="margin-top:24px;font-size:0.9em;">Nos termos da legislação aplicável, o abaixo assinado aprova especificamente as cláusulas do
Art. 1.º (Autodeclaração e responsabilidade), Art. 2.º (Aceitação de Extracredit e
geolocalização) e Art. 3.º (Termos e condições e proibição de majorações).</p>
<div class="signature-box">${val(d.legalRepresentativeName, 30)}</div>
`;

const conventionEN = (d) => `
<h1>EXTRACONOMY STORE MEMBERSHIP AGREEMENT AND SELF-CERTIFICATION</h1>
<p>This document constitutes a binding agreement between the <em>Extraconomy</em> platform
(hereinafter referred to as the "Platform") and the Commercial Partner (hereinafter referred
to as the "Store") who subscribes to this agreement.</p>

<h2>1. Applicant and Store Details (Self-Certification)</h2>
<p>
  The undersigned ${val(d.legalRepresentativeName, 30)},
  acting as Legal Representative / Owner of the company ${val(d.company, 30)},
</p>
<ul>
  <li><strong>Tax ID / VAT Number:</strong> ${val(d.taxId, 20)}</li>
  <li><strong>Store Trade Name:</strong> ${val(d.storeName, 25)}</li>
  <li><strong>Operational Address (Physical Store):</strong>
    ${val(d.address, 20)}, No. ${val(d.number, 5)}</li>
  <li><strong>Postal Code:</strong> ${val(d.postalCode, 8)}
      <strong>City:</strong> ${val(d.city, 15)}
      <strong>State/Province:</strong> ${val(d.state, 5)}</li>
  <li><strong>Merchant Category:</strong> ${val(d.merchantCategory, 20)}</li>
  <li><strong>Contact:</strong> Tel. ${val(d.phone, 15)} Email: ${val(d.email, 25)}</li>
</ul>
<p>Aware of the legal penalties for false statements under applicable law, and under their own
responsibility:</p>

<h3>DECLARES AND SELF-CERTIFIES</h3>
<ol>
  <li><strong>Real Existence of the Point of Sale:</strong> That the commercial activity indicated
    above corresponds to a <strong>genuinely existing physical store</strong>, operational and
    open to the public at the stated address.</li>
  <li><strong>Ownership:</strong> That they hold full legal powers and the necessary authorizations
    to register the activity on the Extraconomy platform.</li>
  <li><strong>Authenticity of Attachments:</strong> That the photographic documentation attached
    to this request (photo of the store exterior/sign) is authentic, recent and faithfully
    represents the current state of the Store.</li>
</ol>

<h2>2. Subject of the Agreement and Geolocation</h2>
<p>Upon approval of this agreement, the Store becomes part of the Extraconomy ecosystem.</p>
<ul>
  <li><strong>Mapping and Visibility:</strong> The Store agrees that its data (Trade name,
    address, category and opening hours) will be included in the Platform's interactive map,
    making it geolocatable and findable by registered users.</li>
  <li><strong>Extracredit Acceptance:</strong> The Store formally and solemnly commits to
    accepting <strong>Extracredit</strong> accumulated by users in their digital wallet as a
    payment method (partial or full, according to the acceptance percentages set in the Store
    profile on the Platform).</li>
  <li><strong>Cashback Offer:</strong> The Store agrees to automatically offer a 1% cashback,
    automatically set in the Extraconomy sales system, on the value of the product or service
    sold through purchase transactions carried out via the transfer between digital wallets of
    Extraconomy users using QR Code technology.</li>
</ul>

<h2>3. Terms and Conditions of Participation</h2>
<p>The Store declares that it has read, understood and fully accepts the general Terms and
Conditions of the Extraconomy platform, with particular attention to the following:</p>
<ul>
  <li><strong>Transaction Management:</strong> Extracredit transactions will be processed through
    the application or digital systems provided by Extraconomy. The Store commits to training its
    staff to correctly manage digital payments.</li>
  <li><strong>Transparency:</strong> The Store commits to not applying price surcharges or
    disadvantageous conditions to users who choose to pay in Extracredit compared to traditional
    customers.</li>
  <li><strong>Data Updates:</strong> It is the Store's responsibility to promptly notify
    Extraconomy of any change of address, temporary/permanent closure or change of management.</li>
</ul>

<h2>4. Required Attachments</h2>
<p>To complete activation on the map, the Store attaches to this form:</p>
<ul>
  <li>☐ <strong>Photo of the store exterior</strong> (clear, visible and with the trade sign
    legible).</li>
  <li>☐ Copy of the Legal Representative's identity document (if the signature is not digital).</li>
</ul>

<h2>5. Personal Data Processing (GDPR)</h2>
<p>Personal data collected will be processed by Extraconomy in accordance with EU Regulation
2016/679. Processing is exclusively for the purpose of providing platform services, map
geolocation and credit circuit management.</p>

<h3>SIGNATURE FOR ACCEPTANCE AND SUBSCRIPTION</h3>
<p><strong>Place and Date:</strong> ${val(d.city, 15)}, ${val(d.date, 15)}</p>
<p><em>The Legal Representative / Store Owner</em> (Digital signature or legible handwritten
signature)</p>
<div class="signature-box">${val(d.legalRepresentativeName, 30)}</div>
<p style="margin-top:24px;font-size:0.9em;">The undersigned specifically approves the clauses of Art. 1 (Self-certification and
liability), Art. 2 (Extracredit acceptance and geolocation) and Art. 3 (Terms and conditions
and prohibition of surcharges).</p>
<div class="signature-box">${val(d.legalRepresentativeName, 30)}</div>
`;

const conventionES = (d) => `
<h1>CONVENIO DE ADHESIÓN Y AUTOCERTIFICACIÓN "STORE EXTRACONOMY"</h1>
<p>El presente documento constituye un acuerdo vinculante entre la plataforma <em>Extraconomy</em>
(en adelante denominada "Plataforma") y el Socio Comercial (en adelante denominado "Store")
que suscribe el presente convenio.</p>

<h2>1. Datos del Solicitante y de la Tienda (Autocertificación)</h2>
<p>
  El/La abajo firmante ${val(d.legalRepresentativeName, 30)},
  en calidad de Representante Legal / Titular de la empresa ${val(d.company, 30)},
</p>
<ul>
  <li><strong>NIF / CIF:</strong> ${val(d.taxId, 20)}</li>
  <li><strong>Nombre Comercial de la Tienda:</strong> ${val(d.storeName, 25)}</li>
  <li><strong>Dirección de la Sede Operativa (Tienda Física):</strong>
    ${val(d.address, 20)}, n.º ${val(d.number, 5)}</li>
  <li><strong>Código Postal:</strong> ${val(d.postalCode, 8)}
      <strong>Ciudad:</strong> ${val(d.city, 15)}
      <strong>Provincia:</strong> ${val(d.state, 5)}</li>
  <li><strong>Categoría del Establecimiento:</strong> ${val(d.merchantCategory, 20)}</li>
  <li><strong>Contacto:</strong> Tel. ${val(d.phone, 15)} Email: ${val(d.email, 25)}</li>
</ul>
<p>Consciente de las sanciones penales previstas en caso de declaraciones falsas conforme a la
legislación vigente, bajo su propia responsabilidad:</p>

<h3>DECLARA Y AUTOCERTIFICA</h3>
<ol>
  <li><strong>Existencia Real del Punto de Venta:</strong> Que la actividad comercial indicada
    corresponde a una <strong>tienda física realmente existente</strong>, operativa y abierta al
    público en la dirección señalada.</li>
  <li><strong>Titularidad:</strong> Que posee los plenos poderes legales y las autorizaciones
    necesarias para registrar la actividad en la plataforma Extraconomy.</li>
  <li><strong>Veracidad de los Anexos:</strong> Que la documentación fotográfica adjunta a la
    presente solicitud (foto del exterior del local/rótulo) es auténtica, reciente y representa
    fielmente el estado actual de la Tienda.</li>
</ol>

<h2>2. Objeto del Convenio y Geolocalización</h2>
<p>Con la aprobación del presente convenio, la Tienda pasa a formar parte del ecosistema
Extraconomy.</p>
<ul>
  <li><strong>Mapeo y Visibilidad:</strong> La Tienda acepta que sus datos (Nombre comercial,
    dirección, categoría y horarios) sean incluidos en el mapa interactivo de la Plataforma,
    siendo así geolocalizable y encontrable por los usuarios registrados.</li>
  <li><strong>Aceptación de Extracredit:</strong> La Tienda se compromete formal y solemnemente
    a aceptar los <strong>Extracredit</strong> acumulados por los usuarios en su cartera digital
    como método de pago (parcial o total, según los porcentajes de aceptación establecidos en su
    perfil Store en la Plataforma).</li>
  <li><strong>Oferta de Cashback:</strong> La Tienda acepta ofrecer automáticamente un cashback
    del 1%, configurado automáticamente en el sistema de ventas de Extraconomy, sobre el valor
    del producto o servicio vendido a través de las transacciones de compra realizadas mediante
    la transferencia entre wallets digitales de usuarios de Extraconomy utilizando la tecnología
    QR Code.</li>
</ul>

<h2>3. Términos y Condiciones de Participación</h2>
<p>La Tienda declara haber leído, comprendido y aceptado íntegramente los Términos y Condiciones
generales de la plataforma Extraconomy, con especial atención a los siguientes puntos:</p>
<ul>
  <li><strong>Gestión de Transacciones:</strong> Las transacciones en Extracredit se realizarán
    a través de la aplicación o los sistemas digitales proporcionados por Extraconomy. La Tienda
    se compromete a formar a su personal para la correcta gestión de los pagos digitales.</li>
  <li><strong>Transparencia:</strong> La Tienda se compromete a no aplicar recargos en el precio
    ni condiciones desfavorables a los usuarios que decidan pagar en Extracredit con respecto a
    los clientes tradicionales.</li>
  <li><strong>Actualización de Datos:</strong> Es responsabilidad de la Tienda comunicar
    puntualmente a Extraconomy cualquier cambio de dirección, cierre temporal/definitivo o cambio
    de gestión.</li>
</ul>

<h2>4. Anexos Obligatorios</h2>
<p>Para completar la activación en el mapa, la Tienda adjunta al presente formulario:</p>
<ul>
  <li>☐ <strong>Foto del exterior de la tienda</strong> (clara, visible y con el rótulo
    comercial legible).</li>
  <li>☐ Copia del documento de identidad del Representante Legal (si la firma no es digital).</li>
</ul>

<h2>5. Tratamiento de Datos Personales (RGPD)</h2>
<p>Los datos personales recogidos serán tratados por Extraconomy de conformidad con el Reglamento
UE 2016/679. El tratamiento tiene como única finalidad la prestación de los servicios de la
plataforma, la geolocalización en el mapa y la gestión del circuito de crédito.</p>

<h3>FIRMA PARA ACEPTACIÓN Y SUSCRIPCIÓN</h3>
<p><strong>Lugar y Fecha:</strong> ${val(d.city, 15)}, ${val(d.date, 15)}</p>
<p><em>El Representante Legal / Titular de la Tienda</em> (Firma digital o firma manuscrita
legible)</p>
<div class="signature-box">${val(d.legalRepresentativeName, 30)}</div>
<p style="margin-top:24px;font-size:0.9em;">De conformidad con la legislación aplicable, el abajo firmante aprueba específicamente las
cláusulas del Art. 1 (Autocertificación y responsabilidad), Art. 2 (Aceptación de Extracredit
y geolocalización) y Art. 3 (Términos y condiciones y prohibición de recargos).</p>
<div class="signature-box">${val(d.legalRepresentativeName, 30)}</div>
`;

const conventionByLocale = { pt: conventionPT, en: conventionEN, it: conventionIT, es: conventionES };

const CSS = `
  body { font-family: Georgia, serif; max-width: 860px; margin: 40px auto; padding: 0 32px 80px; color: #1a1a1a; line-height: 1.7; }
  h1 { font-size: 1.2rem; text-align: center; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 2px solid #1a1a1a; padding-bottom: 12px; margin-bottom: 24px; }
  h2 { font-size: 1rem; margin-top: 28px; border-bottom: 1px solid #ccc; padding-bottom: 4px; }
  h3 { font-size: 0.95rem; margin-top: 20px; }
  ul, ol { padding-left: 24px; }
  li { margin-bottom: 6px; }
  .blank { display: inline-block; border-bottom: 1px solid #555; min-width: 120px; }
  .signature-box { border: 1px solid #aaa; border-radius: 4px; min-height: 60px; margin-top: 12px; padding: 12px 16px; font-style: italic; color: #555; }
  .print-btn { display: block; margin: 32px auto 0; padding: 10px 28px; background: #1DAF61; color: #fff; border: none; border-radius: 6px; font-size: 1rem; cursor: pointer; }
  @media print { .print-btn { display: none; } }
`;

export function openConventionWindow(data) {
  const locale = localStorage.getItem("__extraconomy_locale") || "pt";
  const key = Object.keys(conventionByLocale).find((k) => locale.startsWith(k)) || "pt";
  const bodyHtml = conventionByLocale[key](data);

  const printLabels = {
    pt: "Imprimir / Guardar como PDF",
    en: "Print / Save as PDF",
    it: "Stampa / Salva come PDF",
    es: "Imprimir / Guardar como PDF",
  };

  const html = `<!DOCTYPE html>
<html lang="${key}">
<head>
  <meta charset="UTF-8"/>
  <title>Extraconomy – Convention</title>
  <style>${CSS}</style>
</head>
<body>
  ${bodyHtml}
  <button class="print-btn" onclick="window.print()">${printLabels[key] || printLabels.pt}</button>
</body>
</html>`;

  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (win) {
    win.addEventListener("load", () => URL.revokeObjectURL(url), { once: true });
  }
}
